import { jsx as _jsx } from "react/jsx-runtime";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from "chart.js";
import { Bar } from "react-chartjs-2";
import { useEffect, useMemo, useRef } from "react";
import { BankAccountCurrency } from "@bundles/UIAppBundle/collections/BankAccounts/enum";
import { useTranslate } from "@bluelibs/x-ui";
import { TransactionType } from "@root/api.types";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const TotalTransactionsByDayChart = ({ title, colors = ["rgba(70,70,175,0.8)"], labelResolver, transactionCountDataByDays, className, }) => {
    const t = useTranslate();
    const containerRef = useRef();
    const labels = Object.keys(transactionCountDataByDays);
    const data = Object.values(transactionCountDataByDays);
    const incomes = data.map((tsxArray) => tsxArray.filter((tsx) => tsx.type === TransactionType.income));
    const expenses = data.map((tsxArray) => tsxArray.filter((tsx) => tsx.type === TransactionType.expense));
    const getBarChartOptions = useMemo(() => {
        const amounts = Object.keys(labels).map((_, index) => {
            const totalDayIncome = incomes[index].reduce((prev, curr) => { var _a; return (_a = prev + (curr === null || curr === void 0 ? void 0 : curr.amount)) !== null && _a !== void 0 ? _a : 0; }, 0);
            const totalDayExpense = expenses[index].reduce((prev, curr) => { var _a; return (_a = prev + (curr === null || curr === void 0 ? void 0 : curr.amount)) !== null && _a !== void 0 ? _a : 0; }, 0);
            return {
                totalDayIncome,
                totalDayExpense,
            };
        });
        return {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: "top",
                },
                title: {
                    display: true,
                    text: title,
                },
                tooltip: {
                    callbacks: {
                        footer: (ctx) => {
                            var _a, _b, _c, _d;
                            if (ctx[0].dataset.label === "Income") {
                                return `${t("charts.totalIncome")}: ${((_b = (_a = amounts === null || amounts === void 0 ? void 0 : amounts[ctx[0].dataIndex]) === null || _a === void 0 ? void 0 : _a.totalDayIncome) !== null && _b !== void 0 ? _b : 0).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })} ${BankAccountCurrency.RON}`;
                            }
                            else {
                                return `${t("charts.totalExpense")}: ${((_d = (_c = amounts === null || amounts === void 0 ? void 0 : amounts[ctx[0].dataIndex]) === null || _c === void 0 ? void 0 : _c.totalDayExpense) !== null && _d !== void 0 ? _d : 0).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })} ${BankAccountCurrency.RON}`;
                            }
                        },
                    },
                },
            },
        };
    }, [title, incomes, expenses]);
    const getBarChartData = useMemo(() => ({
        labels: labels,
        datasets: [
            {
                label: t("dashboard.income"),
                data: incomes.map((income) => { var _a; return (_a = income === null || income === void 0 ? void 0 : income.length) !== null && _a !== void 0 ? _a : 0; }),
                borderColor: colors[0],
                backgroundColor: colors[0],
                barThickness: 20,
                maxBarThickness: 20,
            },
            {
                label: t("dashboard.expense"),
                data: expenses.map((expense) => { var _a; return (_a = expense === null || expense === void 0 ? void 0 : expense.length) !== null && _a !== void 0 ? _a : 0; }),
                borderColor: colors[1],
                backgroundColor: colors[1],
                barThickness: 20,
                maxBarThickness: 20,
            },
        ],
    }), [transactionCountDataByDays]);
    useEffect(() => {
        var _a;
        if (containerRef.current) {
            containerRef.current.scrollTo({
                left: (containerRef.current.scrollWidth -
                    ((_a = containerRef.current.parentElement) === null || _a === void 0 ? void 0 : _a.offsetWidth)) /
                    2,
            });
        }
    }, [containerRef.current]);
    return (_jsx("div", Object.assign({ ref: containerRef, className: "bar-chart-parent-container" }, { children: _jsx("div", Object.assign({ className: "bar-chart-container" }, { children: _jsx(Bar, { className: className, options: getBarChartOptions, data: getBarChartData }, void 0) }), void 0) }), void 0));
};
export default TotalTransactionsByDayChart;
